import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var LayerStyleSvg = function LayerStyleSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.633 2.421a3.86 3.86 0 0 0-3.998.3 3.8 3.8 0 0 0-1.287 1.618l-3.298 7.939H6.312v1.495h3.117l-1.255 3.021a5.54 5.54 0 0 1-2.06 2.49A5.64 5.64 0 0 1 3 20.22v1.495c1.41 0 2.787-.413 3.958-1.189a7.04 7.04 0 0 0 2.616-3.164l1.491-3.589h3.29v-1.495h-2.669l3.063-7.372c.162-.39.43-.728.776-.976a2.32 2.32 0 0 1 2.412-.18c.38.193.697.487.917.849l.528.869 1.298-.77-.528-.868a3.8 3.8 0 0 0-1.519-1.409M16.063 18.174l-1.836-2.357 1.2-.911 1.782 2.287 2.8-2.396.991 1.13-2.867 2.453 2.025 2.6-1.2.91-1.97-2.53L13.903 22l-.992-1.13z"
  }));
};
export var LayerStyle = function LayerStyle(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: LayerStyleSvg
  }));
};